import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';


import CookieConsentElement from './CookieConsent';
import App from './App';


import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookieConsentElement/>
  </React.StrictMode>
);


const root2 = ReactDOM.createRoot(document.getElementById('root2'));
root2.render(
  //<React.StrictMode>
    <App/>
  //</React.StrictMode>
);




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
